import React from "react";
import { Collapse } from "reactstrap";
import { NavLink, Link } from "react-router-dom";
import IconDown from "react-icons/lib/md/chevron-right";

// icons
import IconMdAirplanemodeActive from "react-icons/lib/md/airplanemode-active";
import IconMdFlightTakeoff from "react-icons/lib/md/flight-takeoff";
import IconMdFlightLand from "react-icons/lib/md/flight-land";
import IconMdLocationOn from "react-icons/lib/md/location-on";
import IconSearch from "react-icons/lib/md/search";
import IconDashboard from "react-icons/lib/md/dashboard";
import IconMdTimeline from "react-icons/lib/md/timeline";
import IconPDM from "react-icons/lib/md/extension";
import IconManifest from "react-icons/lib/md/layers";
import IconAviation from "react-icons/lib/md/storage";
import IataIcon from "react-icons/lib/md/landscape";
import Tsc from "react-icons/lib/ti/clipboard";
import FTPCredentialIcon from "react-icons/lib/md/card-membership";
import ReportsIcon from "react-icons/lib/md/insert-chart";
import PaymentIcon from "react-icons/lib/md/credit-card";
import ProformaIcon from "react-icons/lib/md/bubble-chart";
import WorkflowIcon from "react-icons/lib/md/group-work";
import IataValidationIcon from "react-icons/lib/md/perm-data-setting";
import InvoiceIcon from "react-icons/lib/md/receipt";
import MakerCheckerIcon from "react-icons/lib/md/change-history";
// import PdmDataEntry from 'react-icons/lib/fa/cloud-upload';
import PdmReport from "react-icons/lib/fa/edit";
// import UploadIcon from 'react-icons/lib/md/cloud-upload';
import InputIcon from "react-icons/lib/md/input";
import UploadIcon from "react-icons/lib/md/cloud-upload";

import PaymentReconciliation from "react-icons/lib/fa/wpforms";
import PdmDataEntry from "react-icons/lib/fa/cloud-upload";
import TicketClassIcon from "react-icons/lib/md/settings-applications";
import { appHelpers } from "../../../../_helpers";
import { appConstants } from "../../../../_constants";
import FinalDestinationReportsIcon from "react-icons/lib/md/airport-shuttle";
import AuditTrailIcon from "react-icons/lib/md/account-box";
import ElasticSearchSyncIcon from "react-icons/lib/md/sync";
import WalletIcon from "react-icons/lib/md/email";
import HelpIcon from "react-icons/lib/md/help-outline";
import UnbilledIcon from "react-icons/lib/md/unarchive";
import TicketSearch from "react-icons/lib/md/question-answer";
import FlightOperationIcon from "react-icons/lib/md/flight";
import PassengerIcon from "react-icons/lib/md/date-range";
import ExchangeRateIcon from "react-icons/lib/md/swap-horiz";
import MdPayment from "react-icons/lib/md/payment";
import MdCompareArrows from "react-icons/lib/md/compare-arrows";
import MdSwapHoriz from "react-icons/lib/md/swap-horiz";

// BiHelpCircle

const SuperAdminMenuComponent = ({
  handleClick,
  selected,
  handleOpen,
  handleDataEntry,
}) => {
  const userRole = appHelpers.getActiveUser().AviRole;

  return (
    <ul className="list-unstyled mt-3 pb-5 nav-list clearfix">
      <li
        onClick={handleClick.bind(this, 0)}
        className={selected === 0 ? "selected" : ""}
      >
        <Link to="/">
          <IconDashboard size="18" />
          <span className="name">DashBoard</span>
        </Link>
      </li>
      <li
        onClick={handleClick.bind(this, 5)}
        className={selected === 5 ? "selected" : ""}
      >
        <Link to="/timeline">
          <IconMdTimeline size="18" />
          <span className="name">Timeline</span>
        </Link>
      </li>
      <li
        onClick={handleClick.bind(this, 30)}
        className={selected === 30 ? "selected" : ""}
      >
        <Link to="#">
          <IconManifest size="18" />
          <span className="name">Manifest</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 30} onClick={handleOpen.bind(this, 30)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="#" onClick={handleDataEntry}>
                <InputIcon size="18" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/upload/manifest" activeClassName="active">
                <UploadIcon size="18" />
                <span className="name">
                  Upload <br />
                  Manifest
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/search" activeClassName="active">
                <IconSearch size="18" />
                <span className="name">
                  Manifest
                  <br /> Report
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/flag-metrics" activeClassName="active">
                <IconSearch size="18" />
                <span className="name">
                  Flag
                  <br /> Metrics
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/ticket-search" activeClassName="active">
                <TicketSearch size="18" />
                <span className="name">
                  Search By
                  <br /> Ticket
                </span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 20)}
        className={selected === 20 ? "selected" : ""}
      >
        <Link to="#">
          <IconAviation size="18" />
          <span className="name">Aviation</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 20} onClick={handleOpen.bind(this, 20)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/airline" activeClassName="active">
                <IconMdAirplanemodeActive
                  size="18"
                  className="icon-airplanemode-active"
                />
                <span className="name">Airline</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/airport" activeClassName="active">
                <IconMdFlightLand size="18" className="icon-flight-land" />
                <span className="name">Airport</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/flight" activeClassName="active">
                <IconMdFlightTakeoff
                  size="18"
                  className="icon-flight-takeoff"
                />
                <span className="name">Flight</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/airline-location" activeClassName="active">
                <IconMdLocationOn size="18" className="icon-location-on" />
                <span className="name">
                  Airline
                  <br /> Locations
                </span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 7)}
        className={selected === 7 ? "selected" : ""}
      >
        <NavLink to="/iata" activeClassName="active">
          <IataIcon size="18" className="icon-flight-takeoff" />
          <span className="name">Iata Report</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 8)}
        className={selected === 8 ? "selected" : ""}
      >
        <NavLink to="/invoice" activeClassName="active">
          <InvoiceIcon size="18" />
          <span className="name">
            Invoice
            <br /> Reconciliation
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 9)}
        className={selected === 9 ? "selected" : ""}
      >
        <NavLink to="/tsc" activeClassName="active">
          <Tsc size="18" className="icon-clipboard" />
          <span className="name">TSC Statement</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 10)}
        className={selected === 10 ? "selected" : ""}
      >
        <NavLink to="/ftp-credentials" activeClassName="active">
          <FTPCredentialIcon size="18" className="icon-card-membership" />
          <span className="name">FTP Credentials</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 11)}
        className={selected === 11 ? "selected" : ""}
      >
        <NavLink to="/reports" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">Reports</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 12)}
        className={selected === 12 ? "selected" : ""}
      >
        <NavLink to="/proforma" activeClassName="active">
          <ProformaIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Proforma
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 33)}
        className={selected === 33 ? "selected" : ""}
      >
        <NavLink to="/final-destination-report" activeClassName="active">
          <FinalDestinationReportsIcon
            size="18"
            className="icon-insert-chart"
          />
          <span className="name">
            Final Destination <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 31)}
        className={selected === 31 ? "selected" : ""}
      >
        <NavLink to="/security-charge-report" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Security Charge
            <br /> Report
          </span>
        </NavLink>
      </li>

      <li
        onClick={handleClick.bind(this, 13)}
        className={selected === 13 ? "selected" : ""}
      >
        <Link to="#">
          <PaymentIcon size="18" />
          <span className="name">Payment</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 13} onClick={handleOpen.bind(this, 13)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/payment-reconciliation" activeClassName="active">
                <PaymentReconciliation size="18" className="icon-Wpforms" />
                <span className="name">
                  Payment
                  <br /> Reconciliation
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/unmatched-payments" activeClassName="active">
                <ReportsIcon size="18" className="icon-insert-chart" />
                <span className="name">
                  Unmatched
                  <br /> Payments
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/unmatched-domestic-payment"
                activeClassName="active"
              >
                <ReportsIcon size="18" className="icon-insert-chart" />
                <span className="name">
                  Unmatched <br /> Domestic
                  <br /> Payment
                </span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 50)}
        className={selected === 50 ? "selected" : ""}
      >
        <Link to="#">
          <IconPDM size="18" />
          <span className="name">PDM</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 50} onClick={handleOpen.bind(this, 50)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/pdm-report" activeClassName="active">
                <PdmReport size="18" className="FaEdit" />
                <span className="name">Report</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/pdm-data-entry" activeClassName="active">
                <PdmDataEntry size="18" className="icon-FaCloudUpload" />
                <span className="name">Data Entry</span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>
      <li
        onClick={handleClick.bind(this, 77)}
        className={selected === 77 ? "selected" : ""}
      >
        <NavLink to="/workflow" activeClassName="active">
          <WorkflowIcon size="18" className="icon-insert-chart" />
          <span className="name">Workflow</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 107)}
        className={selected === 107 ? "selected" : ""}
      >
        <NavLink to="/iata-validation" activeClassName="active">
          <IataValidationIcon size="18" className="icon-insert-chart" />
          <span className="name">IATA Validation</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 60)}
        className={selected === 60 ? "selected" : ""}
      >
        <NavLink to="/billed-per-airport" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Billed per <br /> Airport
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 109)}
        className={selected === 109 ? "selected" : ""}
      >
        <NavLink to="/ticket-class-setup" activeClassName="active">
          <TicketClassIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Ticket Class <br /> Setup
          </span>
        </NavLink>
      </li>
      {userRole !== appConstants.ROLES.SUPER_ADMIN && (
        <li
          onClick={handleClick.bind(this, 108)}
          className={selected === 108 ? "selected" : ""}
        >
          <NavLink to="/elastic-search-sync" activeClassName="active">
            <ElasticSearchSyncIcon size="18" className="icon-insert-chart" />
            <span className="name">
              Elastic Search <br /> Sync
            </span>
          </NavLink>
        </li>
      )}
      {userRole !== appConstants.ROLES.SUPER_ADMIN && (
        <li
          onClick={handleClick.bind(this, 108)}
          className={selected === 108 ? "selected" : ""}
        >
          <NavLink to="/maker-checker" activeClassName="active">
            <MakerCheckerIcon size="18" className="icon-insert-chart" />
            <span className="name">
              Maker <br /> Checker
            </span>
          </NavLink>
        </li>
      )}

      {/* Audit trail */}
      <li
        onClick={handleClick.bind(this, 65)}
        className={selected === 65 ? "selected" : ""}
      >
        <NavLink to="/audit-trail" activeClassName="active">
          <AuditTrailIcon size="18" className="icon-insert-chart" />
          <span className="name">AUDIT TRAIL</span>
        </NavLink>
      </li>

      {/* WALLETS */}

      <li
        onClick={handleClick.bind(this, 40)}
        className={selected === 40 ? "selected" : ""}
      >
        <Link to="#">
          <IconPDM size="18" />
          <span className="name">DISPUTE ENTRY</span>
          <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 40} onClick={handleOpen.bind(this, 40)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/dispute-log" activeClassName="active">
                <WalletIcon size="18" className="FaEdit" />
                <span className="name">Dispute Log</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/airline-wallet-history" activeClassName="active">
                <WalletIcon size="18" className="FaEdit" />
                <span className="name">Wallet History</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/airline-wallet" activeClassName="active">
                <WalletIcon size="18" className="icon-FaCloudUpload" />
                <span className="name">Airline Wallet</span>
              </NavLink>
            </li>
          </ul>
        </Collapse>
      </li>

      <li
        onClick={handleClick.bind(this, 70)}
        className={selected === 70 ? "selected" : ""}
      >
        <NavLink to="/unbilled-passengers" activeClassName="active">
          <UnbilledIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Unbilled <br /> Passenger
          </span>
        </NavLink>
      </li>

      <li
        onClick={handleClick.bind(this, 72)}
        className={selected === 74 ? "selected" : ""}
      >
        <NavLink to="/flight-operations" activeClassName="active">
          <FlightOperationIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Flight <br /> Operations
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/passenger-level-data" activeClassName="active">
          <PassengerIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Passenger level <br /> Data
          </span>
        </NavLink>
      </li>
      {/* old billed per airport */}
      <li
        onClick={handleClick.bind(this, 72)}
        className={selected === 72 ? "selected" : ""}
      >
        <NavLink to="/old-billed-per-airport" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Old Billed per <br /> Airport
          </span>
        </NavLink>
      </li>
      {/* <li
        onClick={handleClick.bind(this, 42)}
        className={selected === 42 ? "selected" : ""}
      >
        <Link to="#">
          <ExchangeRateIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Exchange Rate
            <br /> Management
          </span>
                    <IconDown size="14" className="icon-down" />
        </Link>
        <Collapse isOpen={selected === 42} onClick={handleOpen.bind(this, 42)}>
          <ul className="inner-drop list-unstyled">
            <li>
              <NavLink to="/exchange-rate" activeClassName="active">
                <WalletIcon size="18" className="FaEdit" />
                <span className="name">ALL RATES</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/exchange-rate-history" activeClassName="active">
                <WalletIcon size="18" className="FaEdit" />
                <span className="name">RATE HISTORY</span>
              </NavLink>
            </li>
      
          </ul>
        </Collapse>
      </li> */}
      <li
        onClick={handleClick.bind(this, 76)}
        className={selected === 76 ? "selected" : ""}
      >
        <NavLink to="/exchange-rate" activeClassName="active">
          <MdSwapHoriz size="18" className="FaEdit" />
          <span className="name">
            Exchange Rate
            <br /> Management
          </span>
        </NavLink>
      </li>
      <hr></hr>

      <li
        onClick={handleClick.bind(this, 68)}
        className={selected === 68 ? "selected" : ""}
      >
        <NavLink to="/help-center" activeClassName="active">
          <HelpIcon size="18" className="icon-insert-chart" />
          <span className="name">Help Center</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default SuperAdminMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/components/nav/menu/superAdmin.js